import { BrickInfos, brick_registerer } from '@/components/bricks_infos_core.js'
import BrickDatabase from '@/components/brick_database.vue'

let infos = new BrickInfos()

infos.input = '   '
infos.back_classes = ['fas', 'fa-file', 'text-blue']
infos.front_classes = ['fas', 'fa-database', 'text-white']
infos.name = 'database'
infos.associated_class_name = 'AutomlDatabase'
infos.editing_component_name = 'BrickDatabase'
infos.editing_component = BrickDatabase
infos.descriptions = {
  en: {
    short_tooltip_description: 'Database',
    full_tooltip_description: 'Database from which to extract a table',
    navbar_name: 'Database',
  },
  fr: {
    short_tooltip_description: 'Base de données',
    full_tooltip_description:
      'Base de données depuis laquelle extraire une table',
    navbar_name: 'Base de données',
  },
}
// infos.short_tooltip_description = 'database_short_tooltip'
// infos.full_tooltip_description = 'database_full_tooltip'
// infos.navbar_name = 'database_navbar'
infos.background_color = 'blue'

brick_registerer(infos)
